module.exports = __webpack_public_path__ + "static/media/video.c234e1ce.svg";